var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{staticClass:"pt-6",class:{
    'has-background-light':
      _vm.$route.name == 'Register' || _vm.$route.name == 'Login',
  },attrs:{"id":"app"}},[_c('NavBar',{staticClass:"fixed-navbar",attrs:{"lastNewsTimestamp":_vm.lastNews}}),_c('router-view',{staticClass:"py-3"}),_c('Footer')],1),_c('notifications',{attrs:{"group":"global","position":"bottom right"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }